module.exports = __webpack_public_path__ + "img/course-banner.c59b3b32.png";